import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HeaderAcc } from "../../Components";
import { motion } from "framer-motion";
import { accountService } from "../../Services";
import Footer from "../../Components/Base/Footer";

export default function ValidateEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const [toastList, setToastList] = useState([]);
  const [email, setEmail] = useState(
    location.state ? location.state.email : ""
  );
  const [reason, setReason] = useState(
    location.state ? location.state.reason : ""
  );
  const [userId, setUserId] = useState(
    location.state ? location.state.userId : ""
  );

  const [message, setMessage] = useState("");

  const resendValidateEmailLink = async () => {
    try {
      let res = await accountService.resendValidateEmail(userId);
      if (res.message) {
        setMessage(res.message);
      }
    } catch (err) {
      addToast({
        error: true,
        date: new Date(),
        msg: err.replaceAll(/\<\/?[^\>]+(\>|$)/gi, ""),
      });
    }
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <HeaderAcc />
      <div className="flex flex-col items-center justify-start mt-6 px-4">
        <div className="w-full flex justify-center">
          <div className="flex items-center justify-center pt-4 px-4 pb-2 w-full flex-col box-border">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              exit={{ opacity: 0, y: -20 }}
              className="w-full max-w-md px-8 py-10 bg-white rounded-2xl shadow-lg border border-gray-200 box-border overflow-y-auto max-h-[90vh]"
              style={{
                scrollbarWidth: "thin",
                scrollbarColor: "#e5e7eb transparent",
              }}
            >
              {(email !== "" && email !== undefined) ||
              reason === "resendverification" ? (
                <div className="space-y-6">
                  {/* Icon */}
                  <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 rounded-full bg-emerald-600 flex items-center justify-center shadow-md">
                      <svg
                        className="w-10 h-10 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                  </div>

                  <h2 className="text-2xl font-bold text-center text-gray-800">
                    Validate Your Email
                  </h2>

                  <div className="space-y-4 text-center">
                    <p className="text-gray-700 text-lg font-medium">
                      Please verify your email address
                    </p>

                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                      <p className="text-gray-600 mb-2 text-sm">
                        We sent a verification email to:
                      </p>
                      <p className="text-emerald-700 font-semibold text-base break-all">
                        {email}
                      </p>
                    </div>

                    <p className="text-gray-600 text-sm leading-relaxed">
                      Click the link in that email to complete your signup. If
                      you don't see it, check your spam folder.
                    </p>

                    <div className="pt-4 pb-2">
                      <p className="text-gray-700 font-medium mb-4">
                        Still can't find the email?
                      </p>
                      <button
                        className="w-full bg-gradient-to-r from-emerald-600 to-green-600 text-white font-semibold py-3 px-8 rounded-lg hover:from-emerald-700 hover:to-green-700 transition-all duration-200 shadow-md hover:shadow-lg"
                        onClick={resendValidateEmailLink}
                      >
                        Resend Verification Email
                      </button>
                    </div>

                    {message && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-emerald-50 border border-emerald-300 rounded-lg p-4 mt-4"
                      >
                        <div className="flex items-center justify-center space-x-2">
                          <svg
                            className="w-5 h-5 text-emerald-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <p className="text-emerald-700 font-semibold">
                            {message}
                          </p>
                        </div>
                      </motion.div>
                    )}

                    <div className="pt-4 border-t border-gray-200">
                      <p className="text-gray-600">
                        Return to{" "}
                        <Link
                          to="/account/login"
                          className="text-emerald-600 hover:text-emerald-700 font-semibold hover:underline transition-colors"
                        >
                          login page →
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              ) : reason === "expired" ? (
                <div className="space-y-6">
                  {/* Warning Icon */}
                  <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 rounded-full bg-orange-500 flex items-center justify-center shadow-md">
                      <svg
                        className="w-10 h-10 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                  </div>

                  <h2 className="text-2xl font-bold text-center text-gray-800">
                    Verification Link Expired
                  </h2>

                  <div className="space-y-4 text-center">
                    <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                      <p className="text-gray-700 leading-relaxed">
                        Looks like the verification link has expired. Not to
                        worry, we can send the link again.
                      </p>
                    </div>

                    <div className="pt-4">
                      <button
                        className="w-full bg-gradient-to-r from-emerald-600 to-green-600 text-white font-semibold py-3 px-8 rounded-lg hover:from-emerald-700 hover:to-green-700 transition-all duration-200 shadow-md hover:shadow-lg"
                        onClick={resendValidateEmailLink}
                      >
                        Resend Verification Email
                      </button>
                    </div>

                    {message && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-emerald-50 border border-emerald-300 rounded-lg p-4 mt-4"
                      >
                        <div className="flex items-center justify-center space-x-2">
                          <svg
                            className="w-5 h-5 text-emerald-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <p className="text-emerald-700 font-semibold">
                            {message}
                          </p>
                        </div>
                      </motion.div>
                    )}

                    <div className="pt-4 border-t border-gray-200">
                      <p className="text-gray-600">
                        Return to{" "}
                        <Link
                          to="/account/login"
                          className="text-emerald-600 hover:text-emerald-700 font-semibold hover:underline transition-colors"
                        >
                          login page →
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              ) : reason === "unverified" ? (
                <div className="space-y-6">
                  {/* Error Icon */}
                  <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 rounded-full bg-red-500 flex items-center justify-center shadow-md">
                      <svg
                        className="w-10 h-10 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  </div>

                  <h2 className="text-2xl font-bold text-center text-gray-800">
                    Verification Failed
                  </h2>

                  <div className="space-y-4">
                    <div className="flex items-start space-x-3 bg-red-50 border border-red-300 rounded-lg p-4">
                      <img
                        src={process.env.PUBLIC_URL + "/images/danger.png"}
                        alt="warning"
                        className="w-7 h-7 mt-0.5 flex-shrink-0"
                      />
                      <p className="text-red-700 font-medium leading-relaxed">
                        The email verification link you clicked is invalid.
                      </p>
                    </div>

                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                      <p className="text-gray-700 leading-relaxed text-center">
                        Try copying the entire link from your email and pasting
                        it into your browser, or log in and resend confirmation
                        link.
                      </p>
                    </div>

                    <div className="pt-4 border-t border-gray-200 text-center">
                      <p className="text-gray-600">
                        Return to{" "}
                        <Link
                          to="/account/login"
                          className="text-emerald-600 hover:text-emerald-700 font-semibold hover:underline transition-colors"
                        >
                          login page →
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="w-full mt-8 pt-6 border-t border-gray-200">
                <Footer />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
